import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./pages/Home";
import CarPricePrediction from "./pages/Car Price Prediction";
import FlightFarePrediction from "./pages/Flight Fare Prediction";

function App() {
  return <>
  <Header />
  {/* <div className=" m-2 p-4 rounded-lg shadow-lg bg-violet-500 dark:bg-violet-950 dark:bg-opacity-40 h-full"> */}
  <BrowserRouter className=" m-2 p-4 rounded-lg shadow-lg bg-violet-500 dark:bg-violet-950 dark:bg-opacity-40 h-full">
  <Routes>
    <Route path="/" element={<Home />}></Route>
    <Route path="/Carpriceprediction" element={<CarPricePrediction />}></Route>
    <Route path="/Flightfareprediction" element={<FlightFarePrediction />}></Route>
  </Routes>
  </BrowserRouter>
  {/* </div> */}
  <Footer />
  </>;
}

export default App;
